import React from 'react';
import { Route, Redirect, useLocation, RouteProps } from 'react-router-dom';
import { useAppContext } from '../context';

interface IAuthenticatedRouteProps extends RouteProps {
  children: React.ReactElement;
}

const AuthenticatedRoute: React.FC<IAuthenticatedRouteProps> = ({
  children,
  ...rest
}: IAuthenticatedRouteProps) => {
  const { pathname, search } = useLocation();
  const { isAuthenticated, user } = useAppContext();

  if (!user || !isAuthenticated) {
    return (
      <Redirect
        to={`/login?redirect=${encodeURIComponent(
          pathname
        )}${encodeURIComponent(search)}`}
      />
    );
  }

  return <Route {...rest}>{children}</Route>;
};

export default AuthenticatedRoute;
